import { CooperationStatus } from '~/types';

export const ALLOWED_COOPERATION_STATUSES: CooperationStatus[] = [
  CooperationStatus.PREFERRED_PARTNER,
  CooperationStatus.NEW,
  CooperationStatus.TESTED,
  CooperationStatus.ONBOARDING,
];
